import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { Grid } from "@mui/material";
import { LabReportHeader } from "./components/LabReportHeader";
import { SlagTable } from "./components/SlagTable";
import { TableChemistry } from "@/pages/laboratory/data-entry/components/tables/chemistries/TableChemistry";

export const LabReport = () => {
  const {
    state: { heat, slags },
  } = useHeatReportContext();

  return (
    <>
      <Grid item xs={12} container spacing={2} justifyContent="center">
        <Grid item xs={12}>
          <LabReportHeader />
        </Grid>
      </Grid>

      <Grid item xs={12} container spacing={2} justifyContent="center">
        <Grid item xs={12}>
          <TableChemistry
            key={`lab-heat-report${heat?.HeatId}`}
            assetId={null}
            heatId={heat?.HeatId ?? null}
          />
        </Grid>
      </Grid>

      {slags.length > 0 && (
        <Grid item xs={12} container spacing={2} justifyContent="center">
          <Grid item xs={12}>
            <SlagTable key={`lab-heat-report-slag-${heat?.HeatId}`} />
          </Grid>
        </Grid>
      )}
    </>
  );
};
